// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-img[data-v-1c62351e]{min-height:20px;min-width:none;width:60px}.hidden-element[data-v-1c62351e]{visibility:hidden}.instance-label[data-v-1c62351e]{background:var(--g-background-secondary);border:1px solid var(--v-grayDarkest-lighten2);opacity:.65}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
